module.exports = __webpack_public_path__ + "img/Ningxia Hui-speed.3698398e.png";